import { jsx as _jsx } from "react/jsx-runtime";
var Shield = function Shield(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? "#181B32" : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 4.14655L5 8.08455V8.22955C5 12.9695 7.566 17.3585 11.698 19.6835L12 19.8535L12.302 19.6835C16.434 17.3585 19 12.9695 19 8.22955V8.08455L12 4.14655ZM12 21.8505C11.661 21.8505 11.322 21.7665 11.021 21.5965L10.718 21.4255C5.957 18.7485 3 13.6915 3 8.22955V8.08455C3 7.36555 3.39 6.69755 4.018 6.34255L11.02 2.40455C11.625 2.06455 12.376 2.06355 12.979 2.40355L19.98 6.34155C20.61 6.69755 21 7.36555 21 8.08455V8.22955C21 13.6915 18.043 18.7485 13.282 21.4255L12.98 21.5955C12.678 21.7655 12.339 21.8505 12 21.8505Z",
      fill: color
    })
  });
};
export default Shield;